import React from 'react';
import {
  PlaceholderCard,
  PlaceholderCardDate,
  PlaceholderCardDescription,
  PlaceholderCardImg,
  PlaceholderCardLocation,
  PlaceholderCardPrice
} from './styled';

export interface ItemCardPlaceholderProps {
  isCardsLayout?: boolean;
}

export const ItemCardSkeletonBody: React.FC = () => (
  <>
    <PlaceholderCardImg />
    <PlaceholderCardPrice />
    <PlaceholderCardLocation />
    <PlaceholderCardDescription />
    <PlaceholderCardDate />
  </>
);

export const ItemCardPlaceholder: React.FC<ItemCardPlaceholderProps> = ({
  isCardsLayout = false
}) => (
  <PlaceholderCard isCardsLayout={isCardsLayout}>
    <ItemCardSkeletonBody />
  </PlaceholderCard>
);
